module.exports = __webpack_public_path__ + "img/2.a6a947fd.png";